"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterPingPongMessages = exports.pingPongDefaultOptions = exports.PingPongOptions = exports.PingPongMessages = exports.PongMessage = exports.PingMessage = void 0;
const runtypes_1 = require("runtypes");
exports.PingMessage = (0, runtypes_1.Record)({
    type: (0, runtypes_1.Literal)("ping"),
    nonce: runtypes_1.Number,
});
exports.PongMessage = (0, runtypes_1.Record)({
    type: (0, runtypes_1.Literal)("pong"),
    nonce: runtypes_1.Number,
});
exports.PingPongMessages = (0, runtypes_1.Union)(exports.PingMessage, exports.PongMessage);
exports.PingPongOptions = (0, runtypes_1.Partial)({
    interval: runtypes_1.Number,
    timeout: runtypes_1.Number,
    verbose: runtypes_1.Boolean,
    logDisconnects: runtypes_1.Boolean,
    useOtherMessages: runtypes_1.Boolean,
    usePingMessages: runtypes_1.Boolean,
});
exports.pingPongDefaultOptions = {
    interval: 32 * 1024,
    timeout: 8 * 1024,
    verbose: false,
    logDisconnects: false,
    useOtherMessages: true,
    usePingMessages: true,
};
function filterPingPongMessages(listener) {
    return (event) => {
        try {
            const message = JSON.parse(event.data);
            if (exports.PingPongMessages.guard(message)) {
                return;
            }
            // eslint-disable-next-line no-empty
        }
        catch (err) { }
        return listener(event);
    };
}
exports.filterPingPongMessages = filterPingPongMessages;
//# sourceMappingURL=index.js.map